import { Routes } from '@angular/router';
import { ProvectusCanaryComponent } from '../../components/pages/provectus-canary/provectus-canary.component';
import { FacilityComponent } from '../../components/pages/facility/facility.component';
import { DeviceMapComponent } from '../../components/pages/device-map/device-map.component';
import { FloorComponent } from '../../components/pages/floor/floor.component';
import { DevicePlacementComponent } from '../../components/pages/device-placement/device-placement.component';
import { DeviceHealthComponent } from '../../components/pages/device-health/device-health.component';
import { DevicesComponent } from '../../components/pages/devices/devices.component';
import { AnalyticsComponent } from '../../components/pages/analytics/analytics.component';

export const content: Routes = [
   

    //  {
    //     path: 'aerovera-iq',
    //     component: ProvectusCanaryComponent,
    //     data: {
    //         title: "AeroVera IQ",
    //         breadcrumb: "AeroVera IQ",
    //     },
    // },
    {
        path: 'device-health',
        component: DeviceHealthComponent,
        data: {
            title: "Device Health",
            breadcrumb: "Device Health",
        },
    },
    {
        path: 'analytics',
        component: AnalyticsComponent,
        data: {
            title: "Analytics",
            breadcrumb: "Analytics",
        },
    },
    {
        path: 'device-map',
        component: DeviceMapComponent,
        data: {
            title: "Dashboard",
            breadcrumb: "Dashboard",
        },
    },

     {
        path: 'settings',
        data: {
            title: "Settings",
            breadcrumb: "Settings",
        },
        loadChildren: () => import('../../components/pages/components.routes').then(r => r.Settings)

    },
    
    // {
    //     path: 'device-placement',
    //     component: DevicePlacementComponent,
    //     data: {
    //         title: "Device Placement",
    //         breadcrumb: "Device Placement",
    //     },
    // }
    // ,
    // {
    //     path: 'devices',
    //     component: DevicesComponent,
    //     data: {
    //         title: "Devices",
    //         breadcrumb: "Devices",
    //     },
    // }
];
